import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Card, Column, Divider, Row, TextField, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { TaxDisplayModeSelect } from '~/components/SalesTax/TaxDisplayModeSelect/TaxDisplayModeSelect';
import { useLocaleKeys } from '~/i18n';
const GetDisplayModeSectionTID = (parentTestId)=>getTestIds(parentTestId);
export const DisplayModeSection = (param)=>{
    let { displayMode, label, onDisplayModeChange, onLabelChange } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.displaySection');
    const { DisplayModeSectionTestIds } = useMemo(()=>GetDisplayModeSectionTID(), []);
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'sales_tax_display_card'
        },
        autoHeight: true,
        borderRadius: "m",
        children: /*#__PURE__*/ _jsxs(Column, {
            padding: 24,
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 4,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            children: t.title()
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            children: t.description()
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {}),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 24,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            width: "50%",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: t.pricesLabel()
                            })
                        }),
                        /*#__PURE__*/ _jsx(Column, {
                            width: "50%",
                            children: /*#__PURE__*/ _jsx(TaxDisplayModeSelect, {
                                testId: DisplayModeSectionTestIds.ModeSelect(),
                                value: displayMode,
                                onChange: onDisplayModeChange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 24,
                    alignItems: "center",
                    style: {
                        paddingTop: 16
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            style: {
                                width: '50%'
                            },
                            children: t.labelInputLabel()
                        }),
                        /*#__PURE__*/ _jsx(Column, {
                            style: {
                                width: '50%'
                            },
                            children: /*#__PURE__*/ _jsx(TextField, {
                                bi: {
                                    name: 'sales_tax_label_input'
                                },
                                value: label,
                                onChange: (event)=>onLabelChange(event.target.value)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
